export default __webpack_public_path__ + "static/media/Step3.d03f2fb5.svg";